import { Suspense, lazy } from "react";
import { cn } from "@/lib/utils";
import { type FlockGlobeCanvasProps } from "./FlockGlobeCanvas";

const FlockGlobeCanvas = lazy(() =>
  import("./FlockGlobeCanvas").then((module) => ({
    default: module.FlockGlobeCanvas,
  })),
);

export function LazyFlockGlobeCanvas(props: FlockGlobeCanvasProps) {
  if (import.meta.env.MODE === "test") {
    return (
      <StaticGlobeFallback
        size={props.size}
        className={props.className}
        ready
      />
    );
  }

  return (
    <Suspense
      fallback={
        <StaticGlobeFallback
          size={props.size}
          className={props.className}
          ready={false}
        />
      }
    >
      <FlockGlobeCanvas {...props} />
    </Suspense>
  );
}

function StaticGlobeFallback({
  size,
  className,
  ready,
}: {
  size: number;
  className?: string;
  ready: boolean;
}) {
  return (
    <div
      className={cn(
        "relative rounded-full border border-[rgb(var(--starling-brand-teal)/0.16)] bg-[radial-gradient(circle,rgb(var(--starling-brand-teal)/0.18),transparent_66%)]",
        className,
      )}
      style={{ width: size, height: size }}
      aria-hidden="true"
      data-starling-globe-fallback="true"
      data-starling-globe-ready={ready ? "true" : "false"}
    />
  );
}
